import { env } from "@/env.mjs"

export const isProductionEnvironment = env.NEXT_PUBLIC_ENVIRONMENT === "production"
